var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-grid-column",
    { attrs: { width: 8 } },
    [
      _c(
        "sui-grid-column",
        [
          _c("sui-form-field", { attrs: { required: "" } }, [
            _c("label", [_vm._v("Name")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.$v.agreement.ClientName__c.$model,
                  expression: "$v.agreement.ClientName__c.$model",
                  modifiers: { trim: true },
                },
              ],
              class: {
                "is-invalid":
                  _vm.submitted && _vm.$v.agreement.ClientName__c.$error,
              },
              attrs: {
                type: "text",
                placeholder: "First Name, Middle Initial, Last Name",
              },
              domProps: { value: _vm.$v.agreement.ClientName__c.$model },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.$v.agreement.ClientName__c,
                    "$model",
                    $event.target.value.trim()
                  )
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm.submitted && !_vm.$v.agreement.ClientName__c.required
              ? _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(" Enter first name, middle initial, last name "),
                ])
              : _vm._e(),
          ]),
          _c(
            "sui-form-fields",
            { attrs: { "equal-width": "" } },
            [
              _c("sui-form-field", [
                _c("label", [_vm._v("Company/Trust Name")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agreement.CompanyOrTrust__c,
                      expression: "agreement.CompanyOrTrust__c",
                    },
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "Company Name or Trust Name",
                  },
                  domProps: { value: _vm.agreement.CompanyOrTrust__c },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.agreement,
                        "CompanyOrTrust__c",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c("sui-form-field", [
                _c("label", [_vm._v("Trustee/Corporate Officer Name")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agreement.TrusteeOrCorporateOfficer__c,
                      expression: "agreement.TrusteeOrCorporateOfficer__c",
                    },
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "Trustee/Corporate Officer Name",
                  },
                  domProps: {
                    value: _vm.agreement.TrusteeOrCorporateOfficer__c,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.agreement,
                        "TrusteeOrCorporateOfficer__c",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ],
            1
          ),
          _c("sui-form-field", { attrs: { width: 8 } }, [
            _c("label", [_vm._v("Company/Trust Tax ID")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.agreement.CompanyOrTrustTaxID__c,
                  expression: "agreement.CompanyOrTrustTaxID__c",
                },
              ],
              attrs: { type: "text", placeholder: "Company/Trust Tax ID" },
              domProps: { value: _vm.agreement.CompanyOrTrustTaxID__c },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.agreement,
                    "CompanyOrTrustTaxID__c",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _c(
            "section",
            { staticStyle: { "margin-top": "4em" } },
            [
              _c("sui-form-field", { attrs: { required: "" } }, [
                _c("label", [_vm._v("Home Address")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.agreement.ClientHomeAddressStreet__c.$model,
                      expression:
                        "$v.agreement.ClientHomeAddressStreet__c.$model",
                    },
                  ],
                  class: {
                    "is-invalid":
                      _vm.submitted &&
                      _vm.$v.agreement.ClientHomeAddressStreet__c.$error,
                  },
                  attrs: { type: "text", placeholder: "Street" },
                  domProps: {
                    value: _vm.$v.agreement.ClientHomeAddressStreet__c.$model,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.agreement.ClientHomeAddressStreet__c,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm.submitted &&
                !_vm.$v.agreement.ClientHomeAddressStreet__c.required
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(" Enter street "),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "sui-form-fields",
                [
                  _c(
                    "sui-form-field",
                    { attrs: { width: "six", required: "" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement.ClientHomeAddressCity__c.$model,
                            expression:
                              "$v.agreement.ClientHomeAddressCity__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientHomeAddressCity__c.$error,
                        },
                        attrs: { type: "text", placeholder: "City" },
                        domProps: {
                          value:
                            _vm.$v.agreement.ClientHomeAddressCity__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientHomeAddressCity__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientHomeAddressCity__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter city "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "sui-form-field",
                    { attrs: { width: "six" } },
                    [
                      _c("sui-dropdown", {
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientHomeAddressState__c.$error,
                        },
                        attrs: {
                          placeholder: "State",
                          selection: "",
                          direction: "downward",
                          options: _vm.states,
                        },
                        model: {
                          value:
                            _vm.$v.agreement.ClientHomeAddressState__c.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.agreement.ClientHomeAddressState__c,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.agreement.ClientHomeAddressState__c.$model",
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientHomeAddressState__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter state "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    { attrs: { width: "four", required: "" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement.ClientHomeAddressZipCode__c
                                .$model,
                            expression:
                              "$v.agreement.ClientHomeAddressZipCode__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientHomeAddressZipCode__c.$error,
                        },
                        attrs: { type: "text", placeholder: "Zip" },
                        domProps: {
                          value:
                            _vm.$v.agreement.ClientHomeAddressZipCode__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientHomeAddressZipCode__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientHomeAddressZipCode__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter zip code "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "sui-form-field",
                [
                  _c("sui-checkbox", {
                    attrs: { label: "Home address same as mailing address" },
                    model: {
                      value: _vm.clientHomeAddressSamesAsMailingAddress,
                      callback: function ($$v) {
                        _vm.clientHomeAddressSamesAsMailingAddress = $$v
                      },
                      expression: "clientHomeAddressSamesAsMailingAddress",
                    },
                  }),
                ],
                1
              ),
              _c("sui-form-field", { attrs: { required: "" } }, [
                _c("label", [_vm._v("Mailing Address")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.$v.agreement.ClientMailingAddressStreet__c.$model,
                      expression:
                        "$v.agreement.ClientMailingAddressStreet__c.$model",
                    },
                  ],
                  class: {
                    "is-invalid":
                      _vm.submitted &&
                      _vm.$v.agreement.ClientMailingAddressStreet__c.$error,
                  },
                  attrs: { type: "text", placeholder: "Street" },
                  domProps: {
                    value:
                      _vm.$v.agreement.ClientMailingAddressStreet__c.$model,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.agreement.ClientMailingAddressStreet__c,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm.submitted &&
                !_vm.$v.agreement.ClientMailingAddressStreet__c.required
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(" Enter mailing address "),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "sui-form-fields",
                [
                  _c("sui-form-field", { attrs: { width: "six" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.$v.agreement.ClientMailingAddressCity__c.$model,
                          expression:
                            "$v.agreement.ClientMailingAddressCity__c.$model",
                        },
                      ],
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.ClientMailingAddressCity__c.$error,
                      },
                      attrs: { type: "text", placeholder: "City" },
                      domProps: {
                        value:
                          _vm.$v.agreement.ClientMailingAddressCity__c.$model,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.agreement.ClientMailingAddressCity__c,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.ClientMailingAddressCity__c.required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter city "),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "sui-form-field",
                    { attrs: { width: "six" } },
                    [
                      _c("sui-dropdown", {
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientMailingAddressState__c
                              .$error,
                        },
                        attrs: {
                          placeholder: "State",
                          selection: "",
                          direction: "downward",
                          options: _vm.states,
                        },
                        model: {
                          value:
                            _vm.$v.agreement.ClientMailingAddressState__c
                              .$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.agreement.ClientMailingAddressState__c,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.agreement.ClientMailingAddressState__c.$model",
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientMailingAddressState__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter state "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("sui-form-field", { attrs: { width: "four" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.$v.agreement.ClientMailingAddressZipCode__c
                              .$model,
                          expression:
                            "$v.agreement.ClientMailingAddressZipCode__c.$model",
                        },
                      ],
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.ClientMailingAddressZipCode__c
                            .$error,
                      },
                      attrs: { type: "text", placeholder: "Zip" },
                      domProps: {
                        value:
                          _vm.$v.agreement.ClientMailingAddressZipCode__c
                            .$model,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.agreement.ClientMailingAddressZipCode__c,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.ClientMailingAddressZipCode__c.required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter zip code "),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c("sui-form-field", [
                _c("label", [_vm._v("Work Address")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agreement.ClientWorkAddressStreet__c,
                      expression: "agreement.ClientWorkAddressStreet__c",
                    },
                  ],
                  attrs: { type: "text", placeholder: "Street" },
                  domProps: { value: _vm.agreement.ClientWorkAddressStreet__c },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.agreement,
                        "ClientWorkAddressStreet__c",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c(
                "sui-form-fields",
                [
                  _c("sui-form-field", { attrs: { width: "six" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.agreement.ClientWorkAddressCity__c,
                          expression: "agreement.ClientWorkAddressCity__c",
                        },
                      ],
                      attrs: { type: "text", placeholder: "City" },
                      domProps: {
                        value: _vm.agreement.ClientWorkAddressCity__c,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.agreement,
                            "ClientWorkAddressCity__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "sui-form-field",
                    { attrs: { width: "six" } },
                    [
                      _c("sui-dropdown", {
                        attrs: {
                          placeholder: "State",
                          selection: "",
                          direction: "downward",
                          options: _vm.states,
                        },
                        model: {
                          value: _vm.agreement.ClientWorkAddressState__c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.agreement,
                              "ClientWorkAddressState__c",
                              $$v
                            )
                          },
                          expression: "agreement.ClientWorkAddressState__c",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("sui-form-field", { attrs: { width: "four" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.agreement.ClientWorkAddressZipCode__c,
                          expression: "agreement.ClientWorkAddressZipCode__c",
                        },
                      ],
                      attrs: { type: "text", placeholder: "Zip" },
                      domProps: {
                        value: _vm.agreement.ClientWorkAddressZipCode__c,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.agreement,
                            "ClientWorkAddressZipCode__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "section",
            { staticStyle: { "margin-top": "4em" } },
            [
              _c(
                "sui-form-fields",
                { attrs: { "equal-width": "" } },
                [
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("Cell Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.agreement.ClientCellPhone__c.$model,
                            expression:
                              "$v.agreement.ClientCellPhone__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientCellPhone__c.$error,
                        },
                        attrs: { type: "text", placeholder: "Cell Phone" },
                        domProps: {
                          value: _vm.$v.agreement.ClientCellPhone__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientCellPhone__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientCellPhone__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter cell phone "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("Business Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement.ClientBusinessPhone__c.$model,
                            expression:
                              "$v.agreement.ClientBusinessPhone__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientBusinessPhone__c.$error,
                        },
                        attrs: { type: "text", placeholder: "Business Phone" },
                        domProps: {
                          value: _vm.$v.agreement.ClientBusinessPhone__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientBusinessPhone__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientBusinessPhone__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter business phone "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { "equal-width": "" } },
                [
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("Home Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.agreement.ClientHomePhone__c.$model,
                            expression:
                              "$v.agreement.ClientHomePhone__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientHomePhone__c.$error,
                        },
                        attrs: { type: "text", placeholder: "Home Phone" },
                        domProps: {
                          value: _vm.$v.agreement.ClientHomePhone__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientHomePhone__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientHomePhone__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter home phone "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("Email Address")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement.ClientEmailAddress__c.$model,
                            expression:
                              "$v.agreement.ClientEmailAddress__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientEmailAddress__c.$error,
                        },
                        attrs: {
                          type: "email",
                          name: "clt-email",
                          placeholder: "Email Address",
                        },
                        domProps: {
                          value: _vm.$v.agreement.ClientEmailAddress__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientEmailAddress__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.ClientEmailAddress__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter email address "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-field",
                { attrs: { width: 8, required: "" } },
                [
                  _c("label", [_vm._v("Mail Preference")]),
                  _c("sui-dropdown", {
                    class: {
                      "is-invalid":
                        _vm.submitted &&
                        _vm.$v.agreement.ClientMailPreference__c.$error,
                    },
                    attrs: {
                      placeholder: "Mail Preference",
                      selection: "",
                      direction: "downward",
                      options: _vm.mailPreferenceOptions,
                    },
                    model: {
                      value: _vm.$v.agreement.ClientMailPreference__c.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.agreement.ClientMailPreference__c,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.agreement.ClientMailPreference__c.$model",
                    },
                  }),
                  _vm.submitted &&
                  !_vm.$v.agreement.ClientMailPreference__c.required
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(" Enter mailing preference "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "section",
            { staticStyle: { "margin-top": "4em" } },
            [
              _c(
                "sui-form-field",
                { attrs: { width: 8, required: "" } },
                [
                  _c("label", [_vm._v("Employment Status")]),
                  _c("sui-dropdown", {
                    class: {
                      "is-invalid":
                        _vm.submitted &&
                        _vm.$v.agreement.ClientEmploymentStatus__c.$error,
                    },
                    attrs: {
                      placeholder: "Employment Status",
                      selection: "",
                      direction: "downward",
                      options: _vm.employmentStatusOptions,
                    },
                    model: {
                      value: _vm.$v.agreement.ClientEmploymentStatus__c.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.agreement.ClientEmploymentStatus__c,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.agreement.ClientEmploymentStatus__c.$model",
                    },
                  }),
                  _vm.submitted &&
                  !_vm.$v.agreement.ClientEmploymentStatus__c.required
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(" Enter employment status "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { "equal-width": "" } },
                [
                  _c(
                    "sui-form-field",
                    [
                      _c("Label", [_vm._v("Employer")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreement.ClientEmployer__c,
                            expression: "agreement.ClientEmployer__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Former if retired or unemployed",
                        },
                        domProps: { value: _vm.agreement.ClientEmployer__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreement,
                              "ClientEmployer__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    [
                      _c("Label", [_vm._v("Occupation")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreement.ClientOccupation__c,
                            expression: "agreement.ClientOccupation__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Former if retired or unemployed",
                        },
                        domProps: { value: _vm.agreement.ClientOccupation__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreement,
                              "ClientOccupation__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { inline: "" } },
                [
                  _c(
                    "label",
                    { staticStyle: { "margin-right": "10px!important" } },
                    [
                      _vm._v(
                        " Are you employed by a broker-dealer, securities exchange, or FINRA? "
                      ),
                    ]
                  ),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        model: {
                          value:
                            _vm.agreement.IsClientEmployedByBrokerDealer__c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.agreement,
                              "IsClientEmployedByBrokerDealer__c",
                              $$v
                            )
                          },
                          expression:
                            "agreement.IsClientEmployedByBrokerDealer__c",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { inline: "" } },
                [
                  _c(
                    "label",
                    { staticStyle: { "margin-right": "10px!important" } },
                    [
                      _vm._v(
                        " Are you a senior officer, director, or large shareholder of a public company? "
                      ),
                    ]
                  ),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        model: {
                          value:
                            _vm.agreement
                              .IsClientSeniorOfficerOfPublicCompany__c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.agreement,
                              "IsClientSeniorOfficerOfPublicCompany__c",
                              $$v
                            )
                          },
                          expression:
                            "agreement.IsClientSeniorOfficerOfPublicCompany__c",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.agreement.IsClientSeniorOfficerOfPublicCompany__c
                ? _c("sui-form-field", { attrs: { width: 8 } }, [
                    _c("label", [_vm._v("Public Company Name")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.agreement.ClientPublicCompany__c,
                          expression: "agreement.ClientPublicCompany__c",
                        },
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Public Company Name",
                      },
                      domProps: { value: _vm.agreement.ClientPublicCompany__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.agreement,
                            "ClientPublicCompany__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _c(
                "sui-form-fields",
                { attrs: { "equal-width": "" } },
                [
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("Date of Birth")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.agreement.ClientDoB__c.$model,
                            expression: "$v.agreement.ClientDoB__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientDoB__c.$error,
                        },
                        attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                        domProps: {
                          value: _vm.$v.agreement.ClientDoB__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientDoB__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted && !_vm.$v.agreement.ClientDoB__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter date of birth "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    { attrs: { required: "" } },
                    [
                      _c("Label", [_vm._v("SSN")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.agreement.ClientSSN__c.$model,
                            expression: "$v.agreement.ClientSSN__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.ClientSSN__c.$error,
                        },
                        attrs: { type: "text", placeholder: "SSN" },
                        domProps: {
                          value: _vm.$v.agreement.ClientSSN__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.ClientSSN__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted && !_vm.$v.agreement.ClientSSN__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter social security number "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-field",
                [
                  _c(
                    "sui-form-fields",
                    { attrs: { "equal-width": "" } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Driver's License Number")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.ClientDriversLicense__c.$model,
                              expression:
                                "$v.agreement.ClientDriversLicense__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.ClientDriversLicense__c.$error,
                          },
                          attrs: {
                            type: "text",
                            placeholder: "Driver's License Number",
                          },
                          domProps: {
                            value:
                              _vm.$v.agreement.ClientDriversLicense__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.ClientDriversLicense__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.ClientDriversLicense__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter driver's license number "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [
                          _vm._v(
                            "Driver's License State or Country of Issuance"
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement
                                  .ClientDriversLicenseIssueState__c.$model,
                              expression:
                                "$v.agreement.ClientDriversLicenseIssueState__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.ClientDriversLicenseIssueState__c
                                .$error,
                          },
                          attrs: {
                            type: "text",
                            placeholder: "State or Country of Issuance",
                          },
                          domProps: {
                            value:
                              _vm.$v.agreement.ClientDriversLicenseIssueState__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement
                                  .ClientDriversLicenseIssueState__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.ClientDriversLicenseIssueState__c
                          .required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter drivers license issue state "),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { "equal-width": "" } },
                [
                  _c("sui-form-field", { attrs: { required: "" } }, [
                    _c("label", [_vm._v("Driver's License Issue Date")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.$v.agreement.ClientDriversLicenseIssueDate__c
                              .$model,
                          expression:
                            "$v.agreement.ClientDriversLicenseIssueDate__c.$model",
                        },
                      ],
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.ClientDriversLicenseIssueDate__c
                            .$error,
                      },
                      attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                      domProps: {
                        value:
                          _vm.$v.agreement.ClientDriversLicenseIssueDate__c
                            .$model,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.agreement.ClientDriversLicenseIssueDate__c,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.ClientDriversLicenseIssueDate__c.required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter drivers license issue date "),
                        ])
                      : _vm._e(),
                  ]),
                  _c("sui-form-field", { attrs: { required: "" } }, [
                    _c("label", [_vm._v("Driver's License Expiration Date")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.$v.agreement
                              .ClientDriversLicenseExpirationDate__c.$model,
                          expression:
                            "$v.agreement.ClientDriversLicenseExpirationDate__c.$model",
                        },
                      ],
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.ClientDriversLicenseExpirationDate__c
                            .$error,
                      },
                      attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                      domProps: {
                        value:
                          _vm.$v.agreement.ClientDriversLicenseExpirationDate__c
                            .$model,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.$v.agreement
                              .ClientDriversLicenseExpirationDate__c,
                            "$model",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.ClientDriversLicenseExpirationDate__c
                      .required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter drivers license expiration date "),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }